// how use management (approve, etc)
import React, { Component } from "react";
import Item from "./Item";

export default class HowUse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shares: this.props.shares,
    };
  }

  statusButtons = (share) => {
    const types = ["approved", "denied", "pending"];
    return types.map((type) => {
      const btnClass = share.status === type ? "warning" : "light";
      return (
        <span className="mr-2">
          <button className={`btn btn-sm btn-${btnClass}`}> {type} </button>
        </span>
      );
    });
  };

  render = () => {
    return (
      <div id="how-use-app">
        {this.state.shares.map((item) => (
          <Item item={item} />
        ))}
      </div>
    );
  };
}
